// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"008d7b4f","158":"a9ae325d","453":"9d17525d","473":"63bca4f4","490":"39d5e656","498":"28d2ef40","862":"d0d92c16"}[chunkId] + ".chunk.js";
};